import { Component } from '@angular/core';
import { NavParams} from 'ionic-angular';
import { AppState } from '../../app/app.global';
@Component({
  selector: 'page_error',
  templateUrl: 'error.html'
})
export class ErrorPage {
	errorMsg = "";//错误信息
	constructor (public params: NavParams,public global: AppState) {
		this.errorMsg = params.data.errorMsg;
	}
	
	
}



// WEBPACK FOOTER //
// ./src/pages/error/error.ts